// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleShare_wrapper__aDQeT","shareList":"ArticleShare_shareList__yjc9F"};